import React, { useContext } from 'react';
import { UserContext } from '../../contexts/UserContext';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const user = useContext(UserContext);
  const logged = user?.id !== undefined;
  return (
    <Route
      {...rest}
      render={(props) =>
        logged ? <Component {...props} /> : <Redirect to='/login' />
      }
    />
  );
};


export default PrivateRoute;
